import Vue                      from 'vue'
import Router                   from 'vue-router'
import axios                    from 'axios'
import VueAxios                 from 'vue-axios'
import infiniteScroll           from 'vue-infinite-scroll'
import welcomeDispatcherView    from '@/views/View_welcome_dispatcher'
import detalleTicketView        from '@/views/View_detalle_ticket'
import programacionDeCitasView  from '@/views/View_programacion_de_citas'
import reportesView             from '@/views/View_reportes'
import reportesPrevisualizarView             from '@/components/c_reporte_previsualizar'
import creacionTicketsView            from '@/views/View_creacion_ticket_multiple'
import perfilUsarioView         from '@/views/View_user_profile'
import Notifications            from 'vue-notification'
import usuariosView from '@/views/View_administrador_usuarios'
import moment                   from 'moment'
import newTicketContratoView             from '@/components/New_Ticket_Contrato_View'
import VueUpload                from '@websanova/vue-upload'
import VueUploadHttp            from '@websanova/vue-upload/dist/drivers/http/axios.esm.js'
import goTo                     from 'vuetify/es5/services/goto'
import 'moment/locale/es'
moment.locale('es')

Vue.use(Notifications)
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(infiniteScroll)
Vue.use(VueUpload, {
  http: VueUploadHttp
})
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0
    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }
    return goTo(scrollTo)
  },
  routes: [
    { path: '/login', redirect: '/' },
    {
      path     : '/',
      name     : 'Dashboard',
      component: welcomeDispatcherView
    },
    {
      path     : '/tickets/:tipo/:tipoDeArea?',
      name     : 'listado_tickets',
      component: () => import('@/views/View_tickets.vue'),
      props    : true
    },
    {
      path     : '/ticket-contrato/nuevo',
      name     : 'nuevo_ticket_contrato',
      component: newTicketContratoView
    },
    {
      path     : '/ticket/:numero',
      name     : 'detalle_ticket',
      component: detalleTicketView,
      props    : true
    },
    {
      path     : '/programacion/citas/:id?',
      name     : 'citas',
      component: programacionDeCitasView,
      props    : true
    },
    {
      path     : '/profile',
      name     : 'profile',
      component: perfilUsarioView
    },
    {
      path     : '/reportes',
      name     : 'reportes',
      component: reportesView,
      props    : true
    },
    {
      path     : '/reportes/view/:tipo',
      name     : 'reportes_view',
      component: reportesPrevisualizarView,
      props    : true
    },
    {
      path     : '/ticket/crear/multiple',
      name     : 'ticket_crear_multiple_view',
      component: creacionTicketsView,
      props    : true
    },
    {
      path: '/manager/usuarios',
      name: 'usuarios',
      component: usuariosView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/dispatcher.js